import React, { useEffect, useRef } from 'react';
import './Menu.css';

function Menu({ isOpen, onClose, children, align = 'left' }) {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div ref={menuRef} className={`menu text-non-selectable ${align === 'right' ? 'menu-align-right' : ''}`}>
      {children}
    </div>
  );
}

export default Menu;

